(ns frontend.view.settings2.zap-vaults.sub
  (:require [frontend.state.current-session :as session]
            [frontend.view.settings2.zap-vaults.model :as model]
            [re-frame.core :as rf]
            [reagent.ratom :as ratom]
            [ui.state.session.entity-utils :as entity-utils]))

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db model/root-path)))

(rf/reg-sub
 ::active-tab
 :<-
 [::state]
 (fn [state _]
   (get state model/active-tab-key)))


(rf/reg-sub-raw
 ::default-config
 (fn [_ _]
   (ratom/reaction
    (->> @session/tenant
         :tenant/default-vault-config
         (entity-utils/eid)
         (session/get-entity)))))

(rf/reg-sub
 ::vault-logo
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (or (get state model/logo-key)
       (:vault-config/vault-logo default-config))))

(rf/reg-sub
 ::text-color
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (or (get state model/text-color-key)
       (:vault-config/text-color default-config))))

(rf/reg-sub
 ::button-color
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (or (get state model/button-color-key)
       (:vault-config/button-color default-config))))

(rf/reg-sub
 ::back-url
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (or (get state model/back-url-key)
       (:vault-config/logout-url default-config))))

(rf/reg-sub
 ::back-url-editable?
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (let [modified-value (get state model/back-url-editable?-key)]
     (if (nil? modified-value)
       (:vault-config/allow-url-modification? default-config)
       modified-value))))


(rf/reg-sub
 ::unauthorized-message
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (or (get state model/unauthorized-message-key)
       (:vault-config/no-access-message default-config))))

(rf/reg-sub
 ::unauthorized-message-editable?
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (let [modified-value (get state model/unauthorized-message-editable?-key)]
     (if (nil? modified-value)
       (:vault-config/allow-unauthorized-message-modification? default-config)
       modified-value))))

(rf/reg-sub
 ::disclaimer-message
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (or (get state model/disclaimer-message-key)
       (:vault-config/disclaimer-message default-config))))

(rf/reg-sub
 ::disclaimer-confirm-text
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (or (get state model/disclaimer-confirm-text-key)
       (:vault-config/disclaimer-confirm-text default-config))))

(rf/reg-sub
 ::disclaimer-message-editable?
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (let [modified-value (get state model/disclaimer-message-editable?-key)]
     (if (nil? modified-value)
       (:vault-config/allow-disclaimer-modification? default-config)
       modified-value))))

(rf/reg-sub
 ::teams-editable?
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (let [modified-value (get state model/teams-editable?-key)]
     (if (nil? modified-value)
       (:vault-config/allow-teams-configuration? default-config)
       modified-value))))

(rf/reg-sub
 ::members-editable?
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (let [modified-value (get state model/members-editable?-key)]
     (if (nil? modified-value)
       (:vault-config/allow-members-configuration? default-config)
       modified-value))))


(rf/reg-sub
 ::unsaved-changes
 :<-
 [::state]
 :<-
 [::default-config]
 (fn [[state default-config] _]
   (let [changes (model/unsaved-changes state default-config)]
     (when-not (empty? changes)
       changes))))
